// Claims a review-prompt trigger for a moment that happens entirely in the browser.
//
// Only 3D preview needs this today: it is web's highest-reach value moment (~4,962 users a month)
// and has no server request of its own. Everything else scoreable on web has a controller or a
// server callback, and stays there.
//
// Fire-and-forget by design. A review prompt must never affect the feature it hangs off, so a
// failure here — offline, signed out, CSRF token missing — is swallowed. The server re-validates
// the trigger name and dedupes per session, so this is a hint, not an instruction.
export function claimReviewPromptTrigger(trigger: string): void {
  try {
    const meta = document.querySelector('meta[name="csrf-token"]') as HTMLMetaElement | null;

    void fetch('/review-prompt/track', {
      method: 'POST',
      credentials: 'same-origin',
      headers: {
        'Content-Type': 'application/json',
        ...(meta?.content ? { 'X-CSRF-Token': meta.content } : {})
      },
      body: JSON.stringify({ trigger }),
      keepalive: true
    }).catch(() => undefined);
  } catch {
    // Never let scoring break the thing being scored.
  }
}
